<template>
  <div>
    <div v-html="content"></div>
  </div>
</template>

<script>
  export default {
    props: {
      // 接受的打印数据
      content: {
        type: String,
        default: '',
      },
    },
    data() {
      return {};
    },
    computed: {},
    created() {
      //动态添加自定义字体样式
      let style = document.createElement('style');
      style.type = 'text/css';
      style.innerText =
        "@font-face {font-family:'PingFang-Regular';src:url('https://diary-biku.oss-cn-qingdao.aliyuncs.com/upload_file/common/typeface/2557240976048193.ttf')}";
      document.getElementsByTagName('head')[0].appendChild(style);
    },
    /**页面必要代码Start */
    mounted() {},
  };
</script>
<style>
  @page {
    size: auto A4 landscape;
    margin: 3mm;
  }
</style>
